import { render, staticRenderFns } from "./OracleSendReceiptFailure.vue?vue&type=template&id=bc33a7de&scoped=true"
import script from "./OracleSendReceiptFailure.vue?vue&type=script&lang=js"
export * from "./OracleSendReceiptFailure.vue?vue&type=script&lang=js"
import style0 from "./OracleSendReceiptFailure.vue?vue&type=style&index=0&id=bc33a7de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc33a7de",
  null
  
)

export default component.exports